import { IDepartmentState } from '@/store/department';
import { IDepartmentGetters } from './getters.types';
import { IDepartment, Department } from '@/models';

export const getters: IDepartmentGetters = {
  getDepartments(state: IDepartmentState): IDepartment[] {
    return state.departments.map(data => new Department(data));
  },

  getDepartmentById: (state: IDepartmentState) => (
    id: number
  ): IDepartment | undefined => {
    const data = state.departments.find(department => department.id === id);
    if (!data) {
      return undefined;
    }

    return new Department(data);
  }
};
